module.exports = __webpack_public_path__ + "static/media/insorb-product-img@2x.29a2cd53.png";